// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2QS0u","LeftButtons":"Toolbar_LeftButtons__2BOrJ"};